/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Goal } from '../models/Goal';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GoalsService {
    /**
     * Get Goals
     * Get all goals. By default only returns active goals.
     * @returns Goal Successful Response
     * @throws ApiError
     */
    public static getGoalsApiGoalsGet({
        includeInactive = false,
    }: {
        includeInactive?: boolean,
    }): CancelablePromise<Array<Goal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/goals/',
            query: {
                'include_inactive': includeInactive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Goal
     * Create a new goal.
     * @returns Goal Successful Response
     * @throws ApiError
     */
    public static createGoalApiGoalsPost({
        requestBody,
    }: {
        requestBody: Goal,
    }): CancelablePromise<Goal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/goals/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Goal
     * Get a single goal by ID.
     * @returns Goal Successful Response
     * @throws ApiError
     */
    public static getGoalApiGoalsGoalIdGet({
        goalId,
    }: {
        goalId: number,
    }): CancelablePromise<Goal> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/goals/{goal_id}',
            path: {
                'goal_id': goalId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Goal
     * Update an existing goal.
     * @returns Goal Successful Response
     * @throws ApiError
     */
    public static updateGoalApiGoalsGoalIdPut({
        goalId,
        requestBody,
    }: {
        goalId: number,
        requestBody: Goal,
    }): CancelablePromise<Goal> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/goals/{goal_id}',
            path: {
                'goal_id': goalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Goal
     * Soft delete a goal by marking it inactive.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteGoalApiGoalsGoalIdDelete({
        goalId,
    }: {
        goalId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/goals/{goal_id}',
            path: {
                'goal_id': goalId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
